import { type Enum } from '@webapp/infrastructure/types/Enum'

/**
 * Keys for per-user, identity-scoped preferences. Order-request flow is the
 * first option modeled under user preferences.
 */
export const UserPreferenceKeys = {
  ORDER_REQUEST_FLOW: 'order-request-flow',
} as const

export type UserPreferenceKey = Enum<typeof UserPreferenceKeys>
